<ly-auth>
  <div class="header">
    <div class="header-logo">
      <a href="https://dodd.ly" target="_blank"><ly-logo></ly-logo></a>
    </div>

    <h2>Sign up</h2>
  </div>

  <form [formGroup]="createAccountForm">
    <div class="mb-4">
      <div class="form-control w-full mt-3 hidden">
        <input
          type="text"
          pInputText
          class="input input-bordered w-full"
          formControlName="displayName"
          placeholder="Display name"
        />
      </div>

      <div class="form-control w-full mt-3 hidden">
        <input
          type="tel"
          pInputText
          class="input input-bordered w-full"
          formControlName="phone"
          placeholder="Phone number"
        />
      </div>

      <div class="form-control w-full mt-3">
        <label class="label label-text text-base-content">Email</label>
        <input
          type="text"
          pInputText
          class="input input-bordered w-full"
          formControlName="email"
          placeholder="Email address"
        />
      </div>
      <div class="form-control w-full mt-3">
        <label class="label label-text text-base-content">Password</label>
        <input
          type="password"
          pInputText
          class="input input-bordered w-full"
          formControlName="password"
          placeholder="Password"
        />
      </div>
      <ly-callout
        *ngIf="errorMessage"
        class="mt-3"
        icon="error"
        type="negative"
        >{{ errorMessage }}</ly-callout
      >
    </div>
    <button
      type="submit"
      class="button fluid indigo mb-3"
      [class.proccessing]="isProcessing"
      [disabled]="createAccountForm.invalid"
      (click)="submit()"
    >
      Register
    </button>
    <button
      type="submit"
      class="button fluid indigo outlined icon"
      (click)="signupWithGoogle()"
    >
      <ly-icon size="14px" class="mr-1" icon="google"></ly-icon>
      Sign up with Google
    </button>
    <div class="text-center mt-4 account-exists">
      Already have an account?
      <a
        href="/sign-in"
        class="inline-block hover:text-primary hover:underline hover:cursor-pointer transition duration-200"
      >
        Login
      </a>
    </div>
  </form>

  <div class="text-center mt-5 mb-2 terms-of-service">
    <p>By continuing, you agree to our</p>
    <p>
      <a href="https://dodd.ly/terms-of-service" target="_blank"
        >Terms of Service</a
      >
      and
      <a href="https://dodd.ly/privacy-policy" target="_blank">Privacy Policy</a
      >.
    </p>
    <p>Thrilling stuff, we know.</p>
  </div>
</ly-auth>
